import DokumentForm from "./DokumentForm";

const DodajDokument = () => {
  return <DokumentForm is_edit={false} />;
};

export default DodajDokument;
